import React from 'react'
import styled from 'styled-components'
import { stripUnit } from 'polished'

import Wrapper from 'components/Wrapper'
import Section from 'components/Section'
import { media, mediaDown } from 'styles/media'
import { borderRadius } from 'styles/global'
import { white } from 'styles/colors'
import { H2, lineHeights } from 'styles/typography'
import Feature from './PlusFeature'
import * as spacing from 'styles/spacing'

import TeamLarge from 'icons/team-large.svg'
import GiftLarge from 'icons/gift-large.svg'
import SafetyLarge from 'icons/safety-large.svg'

const Inner = styled.div`
  position: relative; /* Position above hero */
  background-color: #15171e;
  margin-left: -${spacing.large};
  margin-right: -${spacing.large};
  padding: ${spacing.xLarge} ${spacing.large};

  ${media.small`
    margin: 0 auto;
    max-width: 1120px;
    padding: ${spacing.xxLarge};
    border-radius: ${stripUnit(borderRadius) * 2 + 'px'};
  `};

  ${media.medium`
    display: flex;
    padding: ${spacing.xxLarge} ${spacing.xxxLarge};
  `};

  ${media.large`
    padding: 56px;
  `};

  ${media.large`
    padding: 72px;
  `};
`

const HeadingWrap = styled.div`
  margin-bottom: ${spacing.large};

  ${media.small`
    margin-bottom: ${spacing.xLarge};
  `};

  ${media.medium`
    width: 36%;
    padding-right: 4%;
    margin-bottom: 0;
  `};
`

const Heading = styled(H2)`
  color: ${white};
  line-height: ${lineHeights.base};

  &:after {
    content: '';
    height: 3px;
    width: 30px;
    background-color: ${white};
    display: block;
    margin-top: ${spacing.xLarge};

    ${media.large`
      margin-top: ${spacing.xxLarge};
    `};

    ${media.xLarge`
      margin-top: ${spacing.xxxLarge};
    `};

    ${mediaDown.medium`
      display: none;
    `};
  }
`

const Content = styled.main`
  counter-reset: steps;

  ${media.medium`
    width: 64%;
    padding-left: 4%;
  `};
`

const Features = () => (
  <Section>
    <Wrapper>
      <Inner>
        <HeadingWrap>
          <Heading>Shopping on vuse.com now has its rewards.</Heading>
        </HeadingWrap>
        <Content>
          <Feature
            icon={<TeamLarge />}
            heading="Everyone is welcome."
            description="The only thing you need is a vuse.com account."
          />
          <Feature
            icon={<GiftLarge />}
            heading="Unlock new benefits with every tier."
            description="The three status tiers gives you more discounts and offers to enjoy."
          />
          <Feature
            icon={<SafetyLarge />}
            heading="Maintain your status."
            description="As a Vuse Plus member, your status is yours to keep as long as you meet the eligibility requirements."
          />
        </Content>
      </Inner>
    </Wrapper>
  </Section>
)

export default Features
